<template>
  <vx-card class="p-5">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="ยืนยัน"
      back-button-text="ย้อนกลับ"
      next-button-text="ถัดไป"
      @on-complete="checkCardNumber"
    >
      <tab-content title="ผู้ยืนคำขอ (เจ้าของเรือ)" class="mb-5">
        <!-- tab 1 content -->
        <div class="vx-row">
          <div class="vx-col md:w-full w-full mt-5" align="center">
            <div class="box" id="preview">
              <div v-if="logoImage">
                <img :src="logoImage" class="img-show" />
              </div>
              <div v-else>
                <img
                  src="../../../assets/icons/cloud-img.png"
                  width="200"
                  height="200"
                />
              </div>
            </div>
            <div>
              <vs-button
                icon-pack="feather"
                icon="icon-upload"
                class="mt-10"
                color="primary"
                @click="$refs.onChangeLogoImage.click()"
              >
                <span class="d-none d-sm-block">อัปโหลดรูป</span>
              </vs-button>
              <input
                ref="onChangeLogoImage"
                type="file"
                accept=".jpeg,.png,.jpg,GIF"
                :hidden="true"
                @change="onChangeLogoImage"
              />
            </div>
          </div>
          <vs-divider position="center">อัปโหลดรูปตราประทับ(ถ้ามี)</vs-divider>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ชื่อผู้ประกอบการ*"
              v-model="step3.certificateOperateName"
              class="w-full"
              v-validate="'required'"
              name="certificate_operate_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_operate_name')"
              >{{ errors.first("certificate_operate_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              id="card_numbers"
              label="ทะเบียนนิติบุคคลเลขที่*"
              v-model="cardNumber"
              class="w-full"
              v-validate="'required|min:17'"
              maxlength="17"
              name="card_number"
              @change="toggleValidate && checkCardNumber()"
            />
            <span v-if="toggleValidate" class="text-danger text-sm"
              >เลขบัตรประชาชนไม่ถูกต้อง</span
            >
            <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('card_number')"
                >{{ errors.first("card_number") }}</span
              > -->
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ชื่อสถานประกอบการ*"
              v-model="step3.certificateEstablishmentName"
              class="w-auto"
              v-validate="'required'"
              name="certificate_establishment_name"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_establishment_name')"
              >{{ errors.first("certificate_establishment_name") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              id="house_code_number"
              label="เลขรหัสประจำบ้าน"
              v-model="step1.houseCodeNumber"
              class="w-full"
              name="house_code_number"
              placeholder="XXXX-XXXXXX-X"
              @keyup="checkHouseCode()"
              maxlength="13"
            />
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('house_code_number')"
              >{{ errors.first("house_code_number") }}</span
            > -->
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ที่ตั้งสำนักงานใหญ่เลขที่*"
              v-model="step1.registrationOffice"
              class="w-full"
              name="registration_office"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('registration_office')"
              >{{ errors.first("registration_office") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ชื่ออาคาร"
              v-model="step1.buildingName"
              class="w-full"
              name="building_name"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
              <vs-input
                label="เลขที่"
                v-model="step1.address"
                class="w-full"
                name="address"
              />
            <span
              class="text-danger text-sm"
              v-show="errors.has('address')"
              >{{ errors.first("address") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ชั้นที่"
              v-model="step1.floor"
              class="w-auto"
              name="floor"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="หมู่ที่*"
              v-model="step3.certificateVillageNumber"
              class="w-auto"
              name="certificate_village_number"
            />
            <!-- <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_village_number')"
              >{{ errors.first("certificate_village_number") }}</span
            > -->
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ตรอก/ซอย"
              v-model="step3.certificateLane"
              class="w-full"
              name="certificate_lane"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="ถนน"
              v-model="step3.certificateRoad"
              class="w-full"
              name="certificate_road"
            />
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              class="w-full select-large"
              label="จังหวัด*"
              v-model="step3.certificateProvince"
              @change="onProvince('step3')"
              name="certificate_province"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.PROVINCE_NAME"
                v-for="(item, index) in provinceName"
                class="w-full"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_province')"
              >{{ errors.first("certificate_province") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              :disabled="!selectDistrict"
              class="w-full select-large"
              label="อำเภอ/เขต*"
              v-model="step3.certificateDistrict"
              @change="onDistrict('step3')"
              name="certificate_district"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.DISTRICT_NAME"
                v-for="(item, index) in districtName"
                class="w-full"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_district')"
              >{{ errors.first("certificate_district") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-select
              :disabled="!selectSubDistrict"
              class="w-full select-large"
              label="ตำบล/แขวง*"
              v-model="step3.certificateSubDistrict"
              @change="onSubDistrict('step3')"
              name="certificate_sub_district"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item.SUB_DISTRICT_NAME"
                v-for="(item, index) in subDistrictName"
                class="w-full"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_sub_district')"
              >{{ errors.first("certificate_sub_district") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="รหัสไปรษณีย์*"
              v-model="step3.certificatePostalCode"
              class="w-full"
              name="certificate_postal_code"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_postal_code')"
              >{{ errors.first("certificate_postal_code") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="เบอร์โทรศัพท์*"
              v-model="step3.certificatePhoneNumber"
              class="w-full"
              v-validate="'required|numeric|min:9'"
              maxlength="10"
              name="certificate_phone_number"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_phone_number')"
              >{{ errors.first("certificate_phone_number") }}</span
            >
          </div>
          <div class="vx-col md:w-1/4 w-full mt-5">
            <vs-input
              label="อีเมล"
              v-model="step3.certificateEmail"
              class="w-full"
              v-validate="'email'"
              name="certificate_email"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('certificate_email')"
              >{{ errors.first("certificate_email") }}</span
            >
          </div>
        </div>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content
        title="อัปโหลดรูปใบสำคัญแสดงการจดทะเบียนห้างหุ้นส่วนบริษัท*"
        class="mb-5"
      >
        <div class="vx-row">
          <div class="vx-col md:w-full w-full mt-5" align="center">
            <div
              class="box flex flex-wrap content-center justify-center"
              id="preview"
            >
              <div v-if="partnershipsImageURL" align="center">
                <vs-chip
                  v-if="partnershipsImageFiles.type == 'application/pdf'"
                  align="center"
                >
                  <vs-avatar
                    icon-pack="feather"
                    icon="icon-file"
                    class="m-3"
                    style="height: 30px; width: 30px"
                  />
                  <span>{{ partnershipsImageFiles.name }} </span>
                </vs-chip>
                <img v-else :src="partnershipsImageURL" class="img-show" />
              </div>
              <div v-else>
                <img
                  src="../../../assets/icons/cloud-img.png"
                  width="200"
                  height="200"
                />
              </div>
            </div>
            <div>
              <vs-button
                icon-pack="feather"
                icon="icon-upload"
                class="mt-10"
                color="primary"
                @click="$refs.onChangePartnershipsImage.click()"
              >
                <span class="d-none d-sm-block">อัปโหลดรูป</span>
              </vs-button>
              <input
                ref="onChangePartnershipsImage"
                type="file"
                accept=".jpeg,.png,.jpg,GIF,.pdf"
                :hidden="true"
                @change="onChangePartnershipsImage"
                name="partnerships_image"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('partnerships_image')"
                >{{ errors.first("partnerships_image") }}</span
              >
            </div>
          </div>
          <vs-divider position="center"
            >อัปโหลดรูปใบสำคัญแสดงการจดทะเบียนห้างหุ้นส่วนบริษัท</vs-divider
          >
        </div>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="อัปโหลดรูปหนังสือรับรอง" class="mb-5">
        <div class="vx-row">
          <div class="vx-col md:w-full w-full mt-5" align="center">
            <div
              v-if="certificateImageFiles.length != 0"
              class="demo-alignment px-20 flex content-center justify-center"
            >
              <div
                v-for="(item, index) in certificateImageFiles"
                :key="index"
                align="center"
              >
                <vs-chip @click="removeCertificateImageFiles(index)" closable>
                  <vs-avatar
                    v-if="item.type == 'application/pdf'"
                    icon-pack="feather"
                    icon="icon-file"
                    class="m-3"
                    style="height: 30px; width: 30px"
                  />
                  <img
                    v-else
                    :src="certificateImageURL[index]"
                    class="m-3"
                    style="height: 100px; max-width: 150px"
                  />
                  <span>{{ item.name }} </span>
                </vs-chip>
              </div>
            </div>
            <div v-else class="box" id="preview">
              <img
                src="../../../assets/icons/cloud-img.png"
                width="200"
                height="200"
              />
            </div>
            <div>
              <vs-button
                icon-pack="feather"
                icon="icon-upload"
                class="mt-10"
                color="primary"
                @click="$refs.onChangeCertificateImage.click()"
              >
                <span class="d-none d-sm-block">อัปโหลดรูป</span>
              </vs-button>
              <input
                ref="onChangeCertificateImage"
                type="file"
                accept=".jpeg,.png,.jpg,GIF,.pdf"
                :hidden="true"
                @change="onChangeCertificateImage"
                name="certificate_image"
                multiple="multiple"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('certificate_image')"
                >{{ errors.first("certificate_image") }}</span
              >
            </div>
          </div>
          <vs-divider position="center">อัปโหลดรูปใบหนังสือรับรอง</vs-divider>
        </div>
      </tab-content>

      <!-- tab 4 content -->
      <tab-content title="ตั้งรหัสผ่านเพือใช้งาน" class="mb-5">
        <div class="vx-row">
          <vs-row class="mt-5 mb-5">
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <h5 class="text-danger mt-5">
                (รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร)
              </h5>
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                label="ชื่อผู้ใช้งาน"
                class="w-1/4"
                v-model="cardNumberCutDash"
                disabled
                v-validate="'required'"
                name="username"
              />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('username')"
                >{{ errors.first("username") }}</span
              >
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                type="password"
                label="รหัสผ่าน"
                class="w-1/4"
                v-model="step1.password"
                v-validate="'required|min:8'"
                name="password"
              />
              <br />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('password')"
                >{{ errors.first("password") }}</span
              >
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-input
                type="password"
                label="ยืนยันรหัสผ่าน"
                class="w-1/4"
                v-model="step1.confirmPassword"
                v-validate="'required|min:8'"
                name="confirm_password"
              />
            </vs-col>
            <vs-col
              class="mb-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <span
                class="text-danger text-sm"
                v-show="errors.has('confirm_password')"
                >{{ errors.first("confirm_password") }}</span
              >
            </vs-col>
            <!-- <vs-col
              class="mt-5"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-checkbox class="mt-5" v-model="isConfirm"
                >ยืนยันว่าข้อมูลถูกต้อง และเป็นความจริง</vs-checkbox
              >
            </vs-col> -->
          </vs-row>
        </div>
      </tab-content>
    </form-wizard>
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from "sweetalert2";

// For custom error message
import { Validator } from "vee-validate";
import { DICT_USER } from "../../../mock-data/form-validate.js";

import { PERSONTYPE } from "../../../constants/endpoint.js";
// register custom messages
Validator.localize("en", DICT_USER);
export default {
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      step1: {
        id: null,
        title: "",
        other: "",
        firstName: "",
        lastName: "",
        cardNumber: null,
        houseCodeNumber: "",
        registrationOffice: "",
        buildingName: "",
        address: "",
        floor: "",
        villageNumber: "",
        lane: "",
        road: "",
        province: "",
        district: "",
        subDistrict: "",
        postalCode: "",
        phoneNumber: "",
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
        personType: "",
      },
      step3: {
        certificateOperateName: "",
        certificateJuristicNumber: "",
        certificateEstablishmentName: "",
        certificateLane: "",
        certificateVillageNumber: "",
        certificateRoad: "",
        certificateProvince: "",
        certificateDistrict: "",
        certificateSubDistrict: "",
        certificatePostalCode: "",
        certificatePhoneNumber: "",
        certificateEmail: "",
      },
      isConfirm: false,
      checkbox: {
        chkOther: false,
      },
      title: [
        { key: 1, value: "นาย" },
        { key: 2, value: "นาง" },
        { key: 3, value: "นางสาว" },
        { key: 4, value: "อื่นๆ" },
      ],
      provinceName: [],
      districtName: [],
      subDistrictName: [],
      zipCode: null,
      selectDistrict: false,
      selectSubDistrict: false,
      inputZipCode: false,
      url: null,
      cardNumber: "",
      toggleValidate: false,
      cardNumberCutDash: "",
      toggleOther: true,
      // checkPassword:null,
      logoImage: null,
      partnershipsImageURL: null,
      certificateImageURL: [],

      logoImageFiles: null,
      partnershipsImageFiles: null,
      certificateImageFiles: [],
    };
  },
  mounted() {
    this.$store.dispatch("address/getProvince");

    this.provinceName = this.$store.state.address.provinceData;

    $(document).ready(function () {
      $("#card_numbers").bind("keypress", function (evt) {
        var key = String.fromCharCode(evt.which || evt.charCode);
        if (/[\d -]/.test(key) === false) return evt.preventDefault();
      });
    });
    $(function () {
      $("[id*=card_numbers]").on("keypress", function () {
        var number = $(this).val();
        if (number.length == 1) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 6) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 12) {
          $(this).val($(this).val() + "-");
        } else if (number.length == 15) {
          $(this).val($(this).val() + "-");
        }
      });
    });
  },
  methods: {
    formSubmitted() {
      console.log("this.cardNumber ", this.cardNumber);
      if (this.cardNumber) {
        var cutDash = this.cardNumber.split("-");
        var cardNum = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`;

        var cutDashCertificate = this.cardNumber.split("-");
        var cardNumCertificate = `${cutDashCertificate[0]}${cutDashCertificate[1]}${cutDashCertificate[2]}${cutDashCertificate[3]}${cutDashCertificate[4]}`;
      }

      this.$validator.validateAll().then((result) => {
        if (result && this.toggleValidate != true) {
          if (this.step1.password != this.step1.confirmPassword) {
            Swal.fire({
              icon: "warning",
              title: "เกิดข้อผิดพลาด",
              text: "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน",
              showConfirmButton: false,
            });
          } else {
            (async () => {
              const villageNumber = this.step3.certificateVillageNumber
                ? this.step3.certificateVillageNumber
                : "-";
              const lane = this.step3.certificateLane
                ? this.step3.certificateLane
                : "-";
              const road = this.step3.certificateRoad
                ? this.step3.certificateRoad
                : "-";
              const email = this.step3.certificateEmail
                ? this.step3.certificateEmail
                : "-";

              console.log(
                "this.regisInfo.district  ",
                this.step3.certificateDistrict
              );
              console.log(
                "this.regisInfo.subDistrict  ",
                this.step3.certificateSubDistrict
              );

              const { value: accept } = await Swal.fire({
                title: "ยินยอมข้อตกลง",
                html:
                  '<br/><hr/><br/><div style="font-size: 14px">' +
                  "ชื่อผู้ประกอบการ : " +
                  this.step3.certificateOperateName +
                  "<br/>" +
                  "ทะเบียนนิติบุคคลเลขที่ : " +
                  this.formateCardNumber(cardNum) +
                  "<br/>" +
                  "ชื่อสถานประกอบการ : " +
                  this.step3.certificateEstablishmentName +
                  '<b style="margin-left: 20px;"></b>' +
                  "หมู่ที่ : " +
                  villageNumber +
                  '<b style="margin-left: 20px;"></b>' +
                  "ตรอก/ซอย : " +
                  lane +
                  '<b style="margin-left: 20px;"></b>' +
                  "ถนน : " +
                  road +
                  "<br/>" +
                  "จังหวัด : " +
                  this.step3.certificateProvince.PROVINCE_NAME +
                  '<b style="margin-left: 20px;"></b>' +
                  "อำเภอ/เขต : " +
                  this.step3.certificateDistrict.DISTRICT_NAME +
                  '<b style="margin-left: 20px;"></b>' +
                  "ตำบล/แขวง : " +
                  this.step3.certificateSubDistrict.SUB_DISTRICT_NAME +
                  '<b style="margin-left: 20px;"></b>' +
                  "รหัสไปรษณีย์ : " +
                  this.step3.certificatePostalCode +
                  "<br/>" +
                  "เบอร์โทรศัพท์ : " +
                  this.step3.certificatePhoneNumber +
                  '<b style="margin-left: 20px;"></b>' +
                  "อีเมล : " +
                  email +
                  "<br/>" +
                  "</div><br/><hr/><br/>" +
                  '<p style="padding: 5px 10px 5px 10px; font-size: 13px">ข้าพเจ้าขอรับรองว่าข้อความในแบบคำขอที่ยื่นมานี้มีความถูกต้องและเป็นจริงทุกประการ ตลอดจนจะปฏิบัติตามกฎหมายและระเบียบของทางราชการทุกประการ และเมื่อได้รับการติดตั้งอุปกรณ์ระบบสำแดงข้อมูลตัวตนอัตโนมัติ (Automatic Identification System : AIS) จากกรมสรรพสามิตแล้ว ข้าพเจ้าจะดูแลรักษาอุปกรณ์ระบบฯ ดังกล่าวเป็นอย่างดี และหากเกิดการชำรุดเสียหายอันเกิดจากความประมาทเลินเล่อในการปฏิบัติงาน ข้าพเจ้ายินยอมชดใช้ค่าเสียหายและค่าซ่อมแซมอุปกรณ์ระบบฯ ให้แก่กรมสรรพสามิต</p>',
                input: "checkbox",
                inputValue: 0,
                inputPlaceholder: "ยืนยันว่าข้อมูลถูกต้องและเป็นความจริง",
                confirmButtonText: "ยืนยัน",
                confirmButtonColor: "#3085d6",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                width: 900,
                padding: 20,
                inputValidator: (result) => {
                  return (
                    !result && "กรุณายืนยันว่าข้อมูลถูกต้องและเป็นความจริง"
                  );
                },
              });
              if (accept) {
                const province = this.step1.province;
                const district = this.step1.district;
                const subDistrict = this.step1.subDistrict;

                const certificateProvince = this.step3.certificateProvince;
                const certificateDistrict = this.step3.certificateDistrict;
                const certificateSubDistrict =
                  this.step3.certificateSubDistrict;

                var payload = {
                  title:
                    this.step1.title == "อื่นๆ"
                      ? this.step1.other
                      : this.step1.title,
                  firstName: this.step1.firstName,
                  lastName: this.step1.lastName,
                  cardNumber: cardNum,
                  houseCodeNumber: this.step1.houseCodeNumber,
                  registrationOffice: this.step1.registrationOffice,
                  buildingName: this.step1.buildingName,
                  address: this.step1.address,
                  floor: this.step1.floor,
                  villageNumber: this.step1.villageNumber,
                  lane: this.step1.lane,
                  road: this.step1.road,
                  province: province ? province.PROVINCE_NAME : "",
                  district: district ? district.DISTRICT_NAME : "",
                  subDistrict: subDistrict ? subDistrict.SUB_DISTRICT_NAME : "",
                  postalCode: this.step1.postalCode,
                  phoneNumber: this.step1.phoneNumber,
                  email: this.step1.email,
                  username: cardNum,
                  password: this.step1.password,
                  confirmPassword: this.step1.confirmPassword,
                  personType: PERSONTYPE.JURISTIC,
                  certificateOperateName: this.step3.certificateOperateName,
                  certificateJuristicNumber: cardNum, //cardNumCertificate
                  certificateEstablishmentName:
                    this.step3.certificateEstablishmentName,
                  certificateLane: this.step3.certificateLane,
                  certificateVillageNumber: this.step3.certificateVillageNumber,
                  certificateRoad: this.step3.certificateRoad,
                  certificateProvince: certificateProvince
                    ? certificateProvince.PROVINCE_NAME
                    : "",
                  certificateDistrict: certificateDistrict
                    ? certificateDistrict.DISTRICT_NAME
                    : "",
                  certificateSubDistrict: certificateSubDistrict
                    ? certificateSubDistrict.SUB_DISTRICT_NAME
                    : "",
                  certificatePostalCode: this.step3.certificatePostalCode,
                  certificatePhoneNumber: this.step3.certificatePhoneNumber,
                  certificateEmail: this.step3.certificateEmail,
                  partnershipsImageFiles: this.partnershipsImageFiles,
                  certificateImageFiles: this.certificateImageFiles,
                  logoImageFiles: this.logoImageFiles,
                };
                console.log("this is payload", payload);
                this.$store.dispatch("users/setInsertUserJuristic", payload);
              }
            })();
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
          });
        }
      });
    },
    onProvince(key) {
      const province =
        key == "step1" ? this.step1.province : this.step3.certificateProvince;
      this.$store.dispatch(
        "address/selectProvince",
        province ? province.PROVINCE_ID : ""
      );
      this.districtName = this.$store.state.address.districtData;
      this.selectDistrict = true;
    },
    onDistrict(key) {
      const district =
        key == "step1" ? this.step1.district : this.step3.certificateDistrict;
      this.$store.dispatch(
        "address/selectDistrict",
        district ? district.DISTRICT_ID : ""
      );
      this.subDistrictName = this.$store.state.address.subDistrictData;
      this.selectSubDistrict = true;
    },
    onSubDistrict(key) {
      const subDistrict =
        key == "step1"
          ? this.step1.subDistrict
          : this.step3.certificateSubDistrict;
      this.$store.dispatch(
        "address/selectSubDistrict",
        subDistrict ? subDistrict.SUB_DISTRICT_ID : ""
      );
      if (key == "step1") {
        this.step1.postalCode = this.$store.state.address.zipCodeData;
      } else {
        this.step3.certificatePostalCode =
          this.$store.state.address.zipCodeData;
      }
      this.inputZipCode = true;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    checkCardNumber() {
      var total = 0;
      var iPID;
      var chk;
      var Validchk;
      iPID = this.cardNumber.replace(/-/g, "");
      Validchk = iPID.substr(12, 1);
      var j = 0;
      var pidcut;
      for (var n = 0; n < 12; n++) {
        pidcut = parseInt(iPID.substr(j, 1));
        total = total + pidcut * (13 - n);
        j++;
      }

      chk = 11 - (total % 11);

      if (chk == 10) {
        chk = 0;
      } else if (chk == 11) {
        chk = 1;
      }
      // if (chk == Validchk) {
      //   this.toggleValidate = false;
      //   this.formSubmitted();
      //   return true;
      // } else {
      //   this.formSubmitted();
      //   this.toggleValidate = true;
      //   return false;
      // }

      if (!this.toggleValidate) {
        if (chk == Validchk) {
          this.toggleValidate = false;
          this.formSubmitted();
          return true;
        } else {
          this.formSubmitted();
          this.toggleValidate = true;
          return false;
        }
      } else {
        if (chk == Validchk) {
          this.toggleValidate = false;
          return true;
        } else {
          this.toggleValidate = true;
          return false;
        }
      }
    },
    onOther() {
      if (this.step1.title == "อื่นๆ") {
        this.toggleOther = false;
      } else {
        this.toggleOther = true;
      }
    },
    async onChangeLogoImage(e) {
      const file = e.target.files[0];
      this.logoImage = URL.createObjectURL(file);
      this.logoImageFiles = file;
    },
    onChangePartnershipsImage(e) {
      const file = e.target.files[0];
      this.partnershipsImageFiles = file;
      this.partnershipsImageURL = URL.createObjectURL(file);
      // for (const item of e.target.files) {
      //   this.partnershipsImageFiles.push(item)
      //   const url = URL.createObjectURL(item)
      //   this.partnershipsImageURL.push(url)
      // }
    },
    removePartnershipsImageFiles(index) {
      this.partnershipsImageFiles.splice(index, 1);
      this.partnershipsImageURL.splice(index, 1);
    },
    onChangeCertificateImage(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.certificateImageFiles = [];
      this.certificateImageURL = [];
      if (files.length > 20) {
        Swal.fire({
          icon: "warning",
          title: "ไฟล์มีจำนวนเกินที่กำหนด",
          text: "กรุณาอัปโหลดไฟล์ไม่เกิน 20 ไฟล์",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        for (const item of e.target.files) {
          this.certificateImageFiles.push(item);
          const url = URL.createObjectURL(item);
          this.certificateImageURL.push(url);
        }
      }
    },
    removeCertificateImageFiles(index) {
      this.certificateImageFiles.splice(index, 1);
      this.certificateImageURL.splice(index, 1);
    },
    async OCR() {
      this.$vs.loading({});
      const loading = this.$store.state.users.loading;
      await this.$store.dispatch("users/setOCR", this.idCardImageFile);
      const ocrData = this.$store.state.users.ocr;
      // console.log("users.ocr =>>>> ", ocrData.PrefixTH);
      // console.log("text.split ", ocrData.Identification_Number.replace(/\s+/g, ''));
      this.step1.title = ocrData.PrefixTH
        ? ocrData.PrefixTH
        : ocrData.PrefixEN == "Mrs."
        ? "นาง"
        : ocrData.PrefixEN == "Miss."
        ? "นางสาว"
        : ocrData.PrefixEN == "Mr."
        ? "นาย"
        : "อื่นๆ";
      this.step1.firstName = ocrData.NameTH;
      this.step1.lastName = ocrData.LastNameTH;

      const cardNumber = ocrData.Identification_Number.replace(/\s+/g, "");
      this.cardNumber = this.formateCardNumber(cardNumber);

      !loading && this.$vs.loading.close();
    },
    formateCardNumber(cardNumber) {
      return (
        cardNumber &&
        `${cardNumber.substring(0, 1)}-${cardNumber.substring(
          1,
          2
        )}${cardNumber.substring(2, 3)}${cardNumber.substring(
          3,
          4
        )}${cardNumber.substring(4, 5)}-${cardNumber.substring(
          5,
          6
        )}${cardNumber.substring(6, 7)}${cardNumber.substring(
          7,
          8
        )}${cardNumber.substring(8, 9)}${cardNumber.substring(
          9,
          10
        )}-${cardNumber.substring(10, 11)}${cardNumber.substring(
          11,
          12
        )}-${cardNumber.substring(12, 13)}`
      );
    },
    checkHouseCode(){
      $("[id*=house_code_number]").on("keypress", function() {
        let value = $(this).val();
        if (value.length == 4) {
          $(this).val($(this).val() + "-");
        } else if (value.length == 11) {
          $(this).val($(this).val() + "-");
        }
      });
    },
  },
  watch: {
    cardNumber: function () {
      let cutDash = this.cardNumber.split("-");
      let cardNum = `${cutDash[0]}${cutDash[1]}${cutDash[2]}${cutDash[3]}${cutDash[4]}`;
      this.cardNumberCutDash = cardNum;
    },
  },
};
</script>
<style lang="css" scoped>
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  max-width: 370px;
  height: 225px;
}
</style>
